import type { Member, Video } from '../types.ts';
import { fmtDuration } from '../lib/format.ts';
import { youtubeThumbnailUrl } from '../lib/api.ts';
import { shiftLightness } from '../lib/color.ts';
import { useState } from 'react';

interface Props {
  video: Video;
  member: Member;
}

export function Thumbnail({ video, member }: Props) {
  const [imgFailed, setImgFailed] = useState(false);
  const isReplay = video.kind === 'replay';
  const bgA = member.color;
  const bgB = isReplay ? shiftLightness(member.color, -16) : shiftLightness(member.color, +14);

  return (
    <div
      className="ss-thumb"
      style={{ background: `linear-gradient(135deg, ${bgA} 0%, ${bgB} 100%)` }}
    >
      {!imgFailed && (
        <img
          className="ss-thumb__img"
          src={youtubeThumbnailUrl(video.id)}
          alt=""
          loading="lazy"
          onError={() => setImgFailed(true)}
        />
      )}
      {imgFailed && (
        <>
          <div className="ss-thumb__pattern" />
          <div className="ss-thumb__title" title={video.title}>
            {stripBrackets(video.title)}
          </div>
          <div className="ss-thumb__corner">
            <span className="ss-thumb__name">{member.nameKr}</span>
          </div>
        </>
      )}
      <div className="ss-thumb__dur">{fmtDuration(video.duration)}</div>
    </div>
  );
}

function stripBrackets(t: string) {
  const cleaned = t
    .replace(/^【[^】]*】\s*/, '')
    .replace(/^\[[^\]]*\]\s*/, '');
  return cleaned.length > 36 ? cleaned.slice(0, 34) + '…' : cleaned;
}
